export { default, type IRowsToDelete } from './delete-rows-select';
